export default __webpack_public_path__ + "static/media/landing.833419cc.jpg";